/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for penalty types based on the response format schema.
 * @export
 */
export const PenaltyTypeEnum = {
    Disgorgement: 'DISGORGEMENT',
    PrejudgmentInterest: 'PREJUDGMENT_INTEREST',
    Suspension: 'SUSPENSION',
    Termination: 'TERMINATION',
    Censure: 'CENSURE',
    IndustryBar: 'INDUSTRY_BAR',
    PennyStockBar: 'PENNY_STOCK_BAR',
    OfficerDirectorBar: 'OFFICER_DIRECTOR_BAR',
    CeaseAndDesist: 'CEASE_AND_DESIST',
    TemporaryInjunction: 'TEMPORARY_INJUNCTION',
    PermanentInjunction: 'PERMANENT_INJUNCTION',
    CivilPenalty: 'CIVIL_PENALTY',
    Undertaking: 'UNDERTAKING',
    CooperationAgreement: 'COOPERATION_AGREEMENT',
    Other: 'OTHER'
} as const;
export type PenaltyTypeEnum = typeof PenaltyTypeEnum[keyof typeof PenaltyTypeEnum];


export function instanceOfPenaltyTypeEnum(value: any): boolean {
    for (const key in PenaltyTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(PenaltyTypeEnum, key)) {
            if (PenaltyTypeEnum[key as keyof typeof PenaltyTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PenaltyTypeEnumFromJSON(json: any): PenaltyTypeEnum {
    return PenaltyTypeEnumFromJSONTyped(json, false);
}

export function PenaltyTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PenaltyTypeEnum {
    return json as PenaltyTypeEnum;
}

export function PenaltyTypeEnumToJSON(value?: PenaltyTypeEnum | null): any {
    return value as any;
}

export function PenaltyTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PenaltyTypeEnum {
    return value as PenaltyTypeEnum;
}

